import {
    languagesCollection,
    groupsCollection,
} from '@/services/firebaseConfig';

export const translations = {
    state: {
        cart: {
            id: null,
            labels: [],
            languages: [],
        },
        groups: [],
        allLanguages: [],
        importedLabels: [],
    },
    mutations: {
        setImportedLabels(state, payload) {
            if (payload) {
                state.importedLabels = payload;
            } else {
                state.importedLabels = [];
            }
        },
        setAllLanguages(state, payload) {
            if (payload) {
                state.allLanguages = payload;
            } else {
                state.allLanguages = [];
            }
        },
        setAllGroups(state, payload) {
            if (payload) {
                state.groups = payload;
            } else {
                state.groups = [];
            }
        },
        setCartId(state, idCart) {
            state.cart.id = idCart;
        },
        addLabelToCart(state, idLabel) {
            if (state.cart.labels.indexOf(idLabel) === -1) {
                state.cart.labels.push(idLabel);
            }
        },
        removeLabelFromCart(state, idLabel) {
            state.cart.labels = state.cart.labels.filter(function (eachLabel) {
                return !(eachLabel === idLabel);
            });
        },
        clearCart(state) {
            state.cart = {
                id: null,
                labels: [],
                languages: [],
            };
        },
        addLanguageToCart(state, idLanguage) {
            state.cart.languages.push(idLanguage);
        },
        removeLanguageFromCart(state, idLanguage) {
            state.cart.languages = state.cart.languages.filter(function (
                eachLanguage
            ) {
                return !(eachLanguage === idLanguage);
            });
        },
    },
    actions: {
        getAllLanguages(context) {
            let langs = [];

            languagesCollection
                .orderBy('language')
                .get()
                .then((querySnapShot) => {
                    querySnapShot.forEach((doc) => {
                        const data = {
                            id: doc.id,
                            language: doc.data().language,
                            name: doc.data().name,
                            checked: false,
                        };
                        langs.push(data);
                    });

                    context.commit('setAllLanguages', langs);
                });
        },
        getGroups(context) {
            let groupsRaw = [];

            groupsCollection.get().then((querySnapShot) => {
                querySnapShot.forEach((doc) => {
                    const data = {
                        id: doc.id,
                        name: doc.data().name,
                    };
                    groupsRaw.push(data);
                });

                context.commit('setAllGroups', groupsRaw);
            });
        },
    },
    getters: {
        cart: (state) => {
            return state.cart;
        },
        importedLabels: (state) => {
            return state.importedLabels;
        },
        allLanguages: (state) => {
            return state.allLanguages;
        },
        groups: (state) => {
            return state.groups;
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/Translations.js